import { render, staticRenderFns } from "./BuildingDetailManage.vue?vue&type=template&id=759cde6e&scoped=true&"
import script from "./BuildingDetailManage.vue?vue&type=script&lang=js&"
export * from "./BuildingDetailManage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingDetailManage.vue?vue&type=style&index=0&id=759cde6e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759cde6e",
  null
  
)

export default component.exports